// ─── Venue: Split ─────────────────────────────────────────────
// Image on one side, venue info on the other. Desktop side-by-side.

import React from 'react';
import { MapPin } from 'lucide-react';
import { AnimatedSection } from '../../../lib/animations/AnimatedSection';

export default function VenueSplit({ section, data, theme }) {
  const anim = section.animation || {};
  const { venueName, address, mapLink, note, image } = data;
  if (!venueName && !address) return null;

  const googleUrl = `https://maps.google.com/?q=${encodeURIComponent(address || venueName)}`;

  return (
    <section className="px-5 py-20" data-testid="venue-section">
      <div className="max-w-2xl mx-auto">
        <AnimatedSection preset={anim.section || 'fade-up'}>
          <p
            className="text-xs tracking-[0.3em] uppercase mb-8 text-center"
            style={{ color: theme.accent, fontFamily: theme.eyebrowFont }}
          >
            How to Get There
          </p>
        </AnimatedSection>

        <div className="flex flex-col md:flex-row items-center gap-8">
          {/* Image */}
          {image && (
            <AnimatedSection preset={anim.section || 'slide-right'} className="w-full md:w-1/2 flex-shrink-0">
              <div className="aspect-[4/3] rounded-2xl overflow-hidden">
                <img src={image} alt={venueName} className="w-full h-full object-cover" loading="lazy" />
              </div>
            </AnimatedSection>
          )}

          {/* Info */}
          <AnimatedSection preset={anim.section || 'fade-up'} delay={0.15} className={`w-full ${image ? 'md:w-1/2' : ''} text-center md:text-left`}>
            <MapPin className="w-6 h-6 mb-3 mx-auto md:mx-0" style={{ color: theme.accent }} />
            <h3 className="text-lg font-medium mb-1" style={{ color: theme.textPrimary, fontFamily: theme.headingFont }}>
              {venueName}
            </h3>
            {address && (
              <p className="text-sm mb-2" style={{ color: theme.textSecondary }}>{address}</p>
            )}
            {note && (
              <p className="text-xs mt-2 mb-4" style={{ color: theme.textSecondary, opacity: 0.7 }}>{note}</p>
            )}
            <a
              href={mapLink || googleUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full text-xs font-medium tracking-wider transition-all hover:scale-105"
              style={{ background: theme.accent, color: '#fff', fontFamily: theme.eyebrowFont }}
            >
              Open Map
            </a>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
}
